import type {
  AddressOrNative,
  AgentSwapMode,
  ExplicitAddress,
} from '@cronos-app/sdk';
import { useQuery } from '@tanstack/react-query';
import { RefetchInterval } from '@ui/config/ui';
import { useSDK } from '@ui/utils';
import type { Fraction } from 'bi-fraction';

export const useH2ReceiveAmount = (
  params: {
    amountIn: Fraction;
    inputTokenAddress: AddressOrNative;
    inputTokenDecimals: number;
    outputTokenAddress: ExplicitAddress;
    outputTokenDecimals: number;
    slippage: Fraction;
    mode: AgentSwapMode;
  },
  enabled?: boolean,
) => {
  const sdk = useSDK();

  return useQuery({
    queryKey: ['useH2ReceiveAmount', params, sdk],
    queryFn: async () => {
      const swap = sdk.getSwapModule();
      return swap.getReceiveAmount(params);
    },
    refetchInterval: RefetchInterval.Slow,
    enabled: enabled !== false && !!sdk,
  });
};
